import { render, staticRenderFns } from "./SchulteCircle5x5.vue?vue&type=template&id=e4839e40&scoped=true"
import script from "./SchulteCircle5x5.vue?vue&type=script&lang=js"
export * from "./SchulteCircle5x5.vue?vue&type=script&lang=js"
import style0 from "./SchulteCircle5x5.vue?vue&type=style&index=0&id=e4839e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4839e40",
  null
  
)

export default component.exports